import { reduce, find, isNil } from 'ramda';
import { defaults, get } from '../utils';


let i18nData = [
  {
    template_id: 2,
    tag_code: 'adulto',
    has_plural: true,
    active: true,
    id: 10,
    translations: {
      es: {
        tag: 'adulto',
        plural: 'adultos'
      },
      ca: {
        tag: 'adult',
        plural: 'adults'
      },
      en: {
        tag: 'adult/s',
        plural: 'adults'
      },
      it: {
        tag: 'adulto/i',
        plural: 'adulti'
      },
      de: {
        tag: 'erwachsene',
        plural: 'erwachsene'
      },
      ru: {
        tag: '\u0432\u0437\u0440\u043e\u0441\u043b\u044b\u0439',
        plural: '\u0432\u0437\u0440\u043e\u0441\u043b\u044b\u0445'
      },
      nl: {
        tag: 'volwassene',
        plural: 'volwassenen'
      },
      fr: {
        tag: 'adulte',
        plural: 'adultes'
      },
      pt: {
        tag: 'adulto',
        plural: 'adultos'
      },
      zi: {
        tag: '\u6210\u4eba',
        plural: '\u6210\u4eba'
      },
      tr: {
        tag: 'yeti\u015fkin',
        plural: 'yeti\u015fkin'
      },
      ar: {
        tag: '\u0641\u0631\u062f \u0628\u0627\u0644\u063a',
        plural: '\u0623\u0641\u0631\u0627\u062f \u0643\u0628\u0627\u0631'
      },
      hu: {
        tag: 'feln\u0151tt',
        plural: 'feln\u0151ttek'
      },
      cs: {
        tag: 'dosp\u011bl\u00fd',
        plural: 'dosp\u011bl\u00ed'
      },
      sk: {
        tag: 'dospel\u00fd',
        plural: 'dospel\u00ed'
      },
      ro: {
        tag: 'adult',
        plural: 'adul\u021bi'
      },
      pl: {
        tag: 'doros\u0142y',
        plural: 'doro\u015bli'
      }
    }
  },
  {
    template_id: 2,
    tag_code: 'habitaci\u00f3n',
    has_plural: true,
    active: true,
    id: 3,
    translations: {
      ca: {
        tag: 'habitaci\u00f3',
        plural: 'habitacions'
      },
      en: {
        tag: 'room',
        plural: 'rooms'
      },
      it: {
        tag: 'camera',
        plural: 'camere'
      },
      de: {
        tag: 'Zimmer',
        plural: 'Zimmer'
      },
      pt: {
        tag: 'quarto',
        plural: 'quartos'
      },
      ru: {
        tag: '\u041d\u043e\u043c\u0435\u0440',
        plural: '\u041d\u043e\u043c\u0435\u0440\u0430'
      },
      nl: {
        tag: 'kamer',
        plural: 'kamers'
      },
      es: {
        tag: 'habitaci\u00f3n',
        plural: 'habitaciones'
      },
      fr: {
        tag: 'chambre',
        plural: 'Chambres'
      },
      zi: {
        tag: '\u5ba2\u623f',
        plural: '\u5ba2\u623f'
      },
      cs: {
        tag: 'pokoj',
        plural: 'pokoje'
      },
      hu: {
        tag: 'szoba',
        plural: 'szob\u00e1k'
      },
      tr: {
        tag: 'oda',
        plural: 'oda'
      },
      ar: {
        tag: '\u063a\u0631\u0641\u0629',
        plural: '\u063a\u0631\u0641'
      },
      sk: {
        tag: 'izba',
        plural: 'izby'
      },
      ro: {
        tag: 'camer\u0103',
        plural: 'camere'
      },
      pl: {
        tag: 'pok\u00f3j',
        plural: 'pokoje'
      }
    }
  },
  {
    template_id: 2,
    tag_code: 'ni\u00f1o',
    has_plural: true,
    active: true,
    id: 6,
    translations: {
      ca: {
        tag: 'infant',
        plural: 'nens'
      },
      es: {
        tag: 'ni\u00f1o',
        plural: 'ni\u00f1os'
      },
      en: {
        tag: 'child',
        plural: 'children'
      },
      it: {
        tag: 'bambino',
        plural: 'bambini'
      },
      de: {
        tag: 'kind',
        plural: 'kinder'
      },
      pt: {
        tag: 'crian\u00e7a',
        plural: 'crian\u00e7as'
      },
      ru: {
        tag: '\u0440\u0435\u0431\u0435\u043d\u043e\u043a',
        plural: '\u0434\u0435\u0442\u0438'
      },
      nl: {
        tag: 'kind',
        plural: 'kinderen'
      },
      fr: {
        tag: 'enfant',
        plural: 'enfants'
      },
      zi: {
        tag: '\u513f\u7ae5',
        plural: '\u513f\u7ae5'
      },
      tr: {
        tag: '\u00e7ocuk',
        plural: '\u00e7ocuk'
      },
      ar: {
        tag: '\u0637\u0641\u0644',
        plural: '\u0623\u0637\u0641\u0627\u0644'
      },
      hu: {
        tag: 'gyerek',
        plural: 'gyerekek'
      },
      cs: {
        tag: 'd\u00edt\u011b',
        plural: 'd\u011bti'
      },
      sk: {
        tag: 'die\u0165a',
        plural: 'deti'
      },
      ro: {
        tag: 'copil',
        plural: 'copii'
      },
      pl: {
        tag: 'dziecko',
        plural: 'dzieci'
      }
    }
  },
  {
    template_id: 2,
    tag_code: 'entrada',
    has_plural: false,
    active: true,
    id: 7,
    translations: {
      ca: {
        tag: 'entrada'
      },
      en: {
        tag: 'check-in'
      },
      it: {
        tag: 'arrivo'
      },
      de: {
        tag: 'anreise'
      },
      pt: {
        tag: 'entrada'
      },
      ru: {
        tag: '\u0412\u044a\u0435\u0437\u0434'
      },
      nl: {
        tag: 'aankomst'
      },
      fr: {
        tag: 'entr\u00e9e'
      },
      es: {
        tag: 'entrada'
      },
      tr: {
        tag: 'giri\u015f'
      },
      zi: {
        tag: '\u5165\u4f4f'
      },
      ar: {
        tag: '\u062f\u062e\u0648\u0644'
      },
      hu: {
        tag: '\u00e9rkez\u00e9s'
      },
      cs: {
        tag: 'vstup'
      },
      sk: {
        tag: 'n\u00e1stup'
      },
      ro: {
        tag: 'sosire'
      },
      pl: {
        tag: 'zameldowanie'
      }
    }
  },
  {
    template_id: 2,
    tag_code: 'salida',
    has_plural: false,
    active: true,
    id: 9,
    translations: {
      ca: {
        tag: 'sortida'
      },
      en: {
        tag: 'check out'
      },
      it: {
        tag: 'partenza'
      },
      de: {
        tag: 'abreise'
      },
      pt: {
        tag: 'sa\u00edda'
      },
      ru: {
        tag: '\u0432\u044b\u0435\u0437\u0434'
      },
      nl: {
        tag: 'vertrek'
      },
      fr: {
        tag: 'd\u00e9part'
      },
      es: {
        tag: 'salida'
      },
      tr: {
        tag: '\u00e7\u0131k\u0131\u015f'
      },
      zi: {
        tag: '\u9000\u623f'
      },
      ar: {
        tag: '\u0645\u063a\u0627\u062f\u0631\u0629'
      },
      hu: {
        tag: 't\u00e1voz\u00e1s'
      },
      cs: {
        tag: 'check out'
      },
      sk: {
        tag: 'odchod'
      },
      ro: {
        tag: 'plecare'
      },
      pl: {
        tag: 'wymeldowanie'
      }
    }
  },
  {
    template_id: 2,
    tag_code: 'hotel',
    has_plural: true,
    active: true,
    id: 493,
    translations: {
      es: {
        tag: 'hotel',
        plural: 'hoteles'
      },
      ca: {
        tag: 'hotel',
        plural: 'hotels'
      },
      en: {
        tag: 'hotel',
        plural: 'hotels'
      },
      it: {
        tag: 'albergo',
        plural: 'hotels'
      },
      de: {
        tag: 'hotel',
        plural: 'hotels'
      },
      pt: {
        tag: 'hotel',
        plural: 'hotels'
      },
      ru: {
        tag: '\u043e\u0442\u0435\u043b\u044c',
        plural: 'hotels'
      },
      nl: {
        tag: 'hotel',
        plural: 'hotels'
      },
      fr: {
        tag: 'h\u00f4tel',
        plural: 'hotels'
      },
      tr: {
        tag: 'otel',
        plural: 'hotels'
      },
      zi: {
        tag: '\u9152\u5e97',
        plural: 'hotels'
      },
      ar: {
        tag: '\u0641\u0646\u062f\u0642',
        plural: 'hotels'
      },
      hu: {
        tag: 'sz\u00e1lloda',
        plural: 'hotels'
      },
      cs: {
        tag: 'hotel',
        plural: 'hotels'
      },
      sk: {
        tag: 'hotel',
        plural: 'hotels'
      },
      ro: {
        tag: 'hotel',
        plural: 'hotels'
      },
      pl: {
        tag: 'hotel',
        plural: 'hotels'
      }
    }
  },
  {
    template_id: 2,
    tag_code: 'buscar',
    has_plural: false,
    active: true,
    id: 636,
    translations: {
      en: {
        tag: 'Search'
      },
      it: {
        tag: 'Cercare'
      },
      ca: {
        tag: 'buscar'
      },
      de: {
        tag: 'suchen'
      },
      fr: {
        tag: 'Rechercher'
      },
      pt: {
        tag: 'Pesquisar'
      },
      ru: {
        tag: '\u0418\u0441\u043a\u0430\u0442\u044c'
      },
      nl: {
        tag: 'Zoek'
      },
      es: {
        tag: 'buscar'
      },
      tr: {
        tag: 'Search'
      },
      zi: {
        tag: 'Search'
      },
      ar: {
        tag: 'Search'
      },
      hu: {
        tag: 'Search'
      },
      cs: {
        tag: 'Search'
      },
      sk: {
        tag: 'Search'
      },
      ro: {
        tag: 'Search'
      },
      pl: {
        tag: 'Search'
      }
    }
  },
  {
    template_id: 2,
    tag_code: 'confirmar',
    has_plural: false,
    active: true,
    id: 41,
    translations: {
      ca: {
        tag: 'confirmar'
      },
      en: {
        tag: 'confirm'
      },
      it: {
        tag: 'confermare'
      },
      de: {
        tag: 'Best\u00e4tigen'
      },
      pt: {
        tag: 'confirmar'
      },
      ru: {
        tag: '\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c'
      },
      nl: {
        tag: 'Samenvatting'
      },
      fr: {
        tag: 'Confirmer'
      },
      zi: {
        tag: '\u786e\u8ba4'
      },
      es: {
        tag: 'confirmar'
      },
      tr: {
        tag: 'onayla'
      },
      ar: {
        tag: '\u062a\u0623\u0643\u064a\u062f'
      },
      hu: {
        tag: 'meger\u0151s\u00edt\u00e9s'
      },
      cs: {
        tag: 'potvrdit'
      },
      sk: {
        tag: 'potvrdi\u0165'
      },
      ro: {
        tag: 'confirmare'
      },
      pl: {
        tag: 'potwierd\u017a'
      }
    }
  },
  {
    "template_id": 2,
    "tag_code": "desayuno gratis",
    "has_plural": false,
    "active": true,
    "id": 643,
    "translations":
    {
      "ca":
      {
        "tag": "Desayuno gratis"
      },
      "en":
      {
        "tag": "Free breakfast"
      },
      "it":
      {
        "tag": "Colazione gratuita"
      },
      "fr":
      {
        "tag": "Petit-d\u00e9jeuner gratuit"
      },
      "de":
      {
        "tag": "Kostenloses Fr\u00fchst\u00fcck"
      },
      "pt":
      {
        "tag": "Pequeno-almo\u00e7o gr\u00e1tis"
      },
      "ru":
      {
        "tag": "\u0437\u0430\u0432\u0442\u0440\u0430\u043a \u0432\u043a\u043b\u044e\u0447\u0435\u043d"
      },
      "nl":
      {
        "tag": "Gratis ontbijt"
      },
      "es":
      {
        "tag": "desayuno Gratis"
      },
      "tr":
      {
        "tag": "Free breakfast"
      },
      "zi":
      {
        "tag": "Free breakfast"
      },
      "ar":
      {
        "tag": "Free breakfast"
      },
      "hu":
      {
        "tag": "Free breakfast"
      },
      "cs":
      {
        "tag": "Free breakfast"
      },
      "sk":
      {
        "tag": "Free breakfast"
      },
      "ro":
      {
        "tag": "Free breakfast"
      },
      "pl":
      {
        "tag": "Free breakfast"
      }
    }
  }, {
    "template_id": 2,
    "tag_code": "no se han encontrado destinos con este nombre",
    "has_plural": false,
    "active": true,
    "id": 642,
    "translations":
    {
      "en":
      {
        "tag": "No results for destinations with this name"
      },
      "it":
      {
        "tag": "Non \u00e8 stata trovata nessuna destinazione con questo nome"
      },
      "fr":
      {
        "tag": "Aucune destination avec ce nom trouv\u00e9e"
      },
      "de":
      {
        "tag": "Mit diesem Namen wurden keine Reiseziele gefunden"
      },
      "pt":
      {
        "tag": "N\u00e3o foram encontrados destinos com este nome"
      },
      "ru":
      {
        "tag": "\u041d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e \u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0439 \u0441 \u044d\u0442\u0438\u043c \u043d\u0430\u0437\u0432\u0430\u043d\u0438\u0435\u043c"
      },
      "nl":
      {
        "tag": "Er werden geen bestemmingen gevonden met deze naam"
      },
      "ca":
      {
        "tag": "No se han encontrado destinos con este nombre"
      },
      "es":
      {
        "tag": "no se han encontrado destinos con este nombre"
      },
      "tr":
      {
        "tag": "No results for destinations with this name"
      },
      "zi":
      {
        "tag": "No results for destinations with this name"
      },
      "ar":
      {
        "tag": "No results for destinations with this name"
      },
      "hu":
      {
        "tag": "No results for destinations with this name"
      },
      "cs":
      {
        "tag": "No results for destinations with this name"
      },
      "sk":
      {
        "tag": "No results for destinations with this name"
      },
      "ro":
      {
        "tag": "No results for destinations with this name"
      },
      "pl":
      {
        "tag": "No results for destinations with this name"
      }
    }
  },
  {
    "template_id": 2,
    "tag_code": "no se han encontrado destinos con este nombre",
    "has_plural": false,
    "active": true,
    "id": 642,
    "translations":
    {
      "en":
      {
        "tag": "No results for destinations with this name"
      },
      "it":
      {
        "tag": "Non \u00e8 stata trovata nessuna destinazione con questo nome"
      },
      "fr":
      {
        "tag": "Aucune destination avec ce nom trouv\u00e9e"
      },
      "de":
      {
        "tag": "Mit diesem Namen wurden keine Reiseziele gefunden"
      },
      "pt":
      {
        "tag": "N\u00e3o foram encontrados destinos com este nome"
      },
      "ru":
      {
        "tag": "\u041d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e \u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0439 \u0441 \u044d\u0442\u0438\u043c \u043d\u0430\u0437\u0432\u0430\u043d\u0438\u0435\u043c"
      },
      "nl":
      {
        "tag": "Er werden geen bestemmingen gevonden met deze naam"
      },
      "ca":
      {
        "tag": "No se han encontrado destinos con este nombre"
      },
      "es":
      {
        "tag": "no se han encontrado destinos con este nombre"
      },
      "tr":
      {
        "tag": "No results for destinations with this name"
      },
      "zi":
      {
        "tag": "No results for destinations with this name"
      },
      "ar":
      {
        "tag": "No results for destinations with this name"
      },
      "hu":
      {
        "tag": "No results for destinations with this name"
      },
      "cs":
      {
        "tag": "No results for destinations with this name"
      },
      "sk":
      {
        "tag": "No results for destinations with this name"
      },
      "ro":
      {
        "tag": "No results for destinations with this name"
      },
      "pl":
      {
        "tag": "No results for destinations with this name"
      }
    }
  },
  {
    "template_id": 2,
    "tag_code": "ir al listado de hoteles",
    "has_plural": false,
    "active": true,
    "id": 640,
    "translations":
    {
      "ca":
      {
        "tag": "Ir al listado de hoteles"
      },
      "en":
      {
        "tag": "See all hotels"
      },
      "it":
      {
        "tag": "See all hotels"
      },
      "de":
      {
        "tag": "See all hotels"
      },
      "pt":
      {
        "tag": "See all hotels"
      },
      "ru":
      {
        "tag": "See all hotels"
      },
      "nl":
      {
        "tag": "See all hotels"
      },
      "fr":
      {
        "tag": "See all hotels"
      },
      "tr":
      {
        "tag": "See all hotels"
      },
      "zi":
      {
        "tag": "See all hotels"
      },
      "ar":
      {
        "tag": "See all hotels"
      },
      "hu":
      {
        "tag": "See all hotels"
      },
      "cs":
      {
        "tag": "See all hotels"
      },
      "sk":
      {
        "tag": "See all hotels"
      },
      "ro":
      {
        "tag": "See all hotels"
      },
      "pl":
      {
        "tag": "See all hotels"
      },
      "es":
      {
        "tag": "ir al listado de hoteles"
      }
    }
  },
  {
    "template_id": 2,
    "tag_code": "\u00bfQuieres a\u00f1adir un vuelo?",
    "has_plural": false,
    "active": true,
    "id": 645,
    "translations":
    {
      "ca":
      {
        "tag": "\u00bfQuieres a\u00f1adir un vuelo?"
      },
      "en":
      {
        "tag": "Do you want to add a flight?"
      },
      "it":
      {
        "tag": "Do you want to add a flight?"
      },
      "de":
      {
        "tag": "Do you want to add a flight?"
      },
      "pt":
      {
        "tag": "Do you want to add a flight?"
      },
      "ru":
      {
        "tag": "Do you want to add a flight?"
      },
      "nl":
      {
        "tag": "Do you want to add a flight?"
      },
      "fr":
      {
        "tag": "Do you want to add a flight?"
      },
      "tr":
      {
        "tag": "Do you want to add a flight?"
      },
      "zi":
      {
        "tag": "Do you want to add a flight?"
      },
      "ar":
      {
        "tag": "Do you want to add a flight?"
      },
      "hu":
      {
        "tag": "Do you want to add a flight?"
      },
      "cs":
      {
        "tag": "Do you want to add a flight?"
      },
      "sk":
      {
        "tag": "Do you want to add a flight?"
      },
      "ro":
      {
        "tag": "Do you want to add a flight?"
      },
      "pl":
      {
        "tag": "Do you want to add a flight?"
      },
      "es":
      {
        "tag": "\u00bfQuieres a\u00f1adir un vuelo?"
      }
    }
  },
  {
    "template_id": 2,
    "tag_code": "vuelo + hotel",
    "has_plural": false,
    "active": true,
    "id": 76,
    "translations":
    {
      "en":
      {
        "tag": "Flight + Hotel"
      },
      "it":
      {
        "tag": "Volo + Hotel"
      },
      "de":
      {
        "tag": "Flug + Hotel"
      },
      "pt":
      {
        "tag": "Voo + Hotel"
      },
      "ru":
      {
        "tag": "\u0420\u0435\u0439\u0441 + O\u0442\u0435\u043b\u044c"
      },
      "nl":
      {
        "tag": "Vlucht + Hotel"
      },
      "fr":
      {
        "tag": "Vol + H\u00f4tel"
      },
      "es":
      {
        "tag": "vuelo + hotel"
      },
      "ca":
      {
        "tag": "vol + hotel"
      },
      "tr":
      {
        "tag": "Flight + Hotel"
      },
      "zi":
      {
        "tag": "Flight + Hotel"
      },
      "ar":
      {
        "tag": "Flight + Hotel"
      },
      "hu":
      {
        "tag": "Flight + Hotel"
      },
      "cs":
      {
        "tag": "Flight + Hotel"
      },
      "sk":
      {
        "tag": "Flight + Hotel"
      },
      "ro":
      {
        "tag": "Flight + Hotel"
      },
      "pl":
      {
        "tag": "Flight + Hotel"
      }
    }
  },
  {
    "template_id": 2,
    "tag_code": "buscar por destino o por hotel",
    "has_plural": false,
    "active": true,
    "id": 637,
    "translations":
    {
      "en":
      {
        "tag": "Search by destination or by hotel"
      },
      "ca":
      {
        "tag": "Buscar por destino o por hotel"
      },
      "it":
      {
        "tag": "Cerca per destinazione o per hotel"
      },
      "fr":
      {
        "tag": "Rechercher par destination ou par h\u00f4tel"
      },
      "de":
      {
        "tag": "Suche nach Reiseziel oder Hotel"
      },
      "pt":
      {
        "tag": "Pesquisar por destino ou por hotel"
      },
      "ru":
      {
        "tag": "\u041f\u043e\u0438\u0441\u043a \u043f\u043e \u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u044e \u0438\u043b\u0438 \u043e\u0442\u0435\u043b\u044e"
      },
      "nl":
      {
        "tag": "Op bestemming of op hotel zoeken"
      },
      "es":
      {
        "tag": "buscar por destino o por hotel"
      },
      "tr":
      {
        "tag": "Search by destination or by hotel"
      },
      "zi":
      {
        "tag": "Search by destination or by hotel"
      },
      "ar":
      {
        "tag": "Search by destination or by hotel"
      },
      "hu":
      {
        "tag": "Search by destination or by hotel"
      },
      "cs":
      {
        "tag": "Search by destination or by hotel"
      },
      "sk":
      {
        "tag": "Search by destination or by hotel"
      },
      "ro":
      {
        "tag": "Search by destination or by hotel"
      },
      "pl":
      {
        "tag": "Search by destination or by hotel"
      }
    }
  },
  {
    "template_id": 2,
    "tag_code": "mejor precio garantizado",
    "has_plural": false,
    "active": true,
    "id": 2,
    "translations":
    {
      "ca":
      {
        "tag": "millor preu garantit"
      },
      "en":
      {
        "tag": "best price guaranteed"
      },
      "fr":
      {
        "tag": "prix minimum garanti"
      },
      "it":
      {
        "tag": "prezzo minimo garantito"
      },
      "de":
      {
        "tag": "best preis garantie"
      },
      "pt":
      {
        "tag": "garantia de menor pre\u00e7o"
      },
      "ru":
      {
        "tag": "\u0421\u0430\u043c\u0430\u044f \u043d\u0438\u0437\u043a\u0430\u044f \u0433\u0430\u0440\u0430\u043d\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u043d\u0430\u044f \u0446\u0435\u043d\u0430"
      },
      "nl":
      {
        "tag": "beste prijs garantie"
      },
      "es":
      {
        "tag": "mejor precio garantizado"
      },
      "tr":
      {
        "tag": "en iyi fiyat garantisi"
      },
      "zi":
      {
        "tag": "\u6700\u4f4e\u4ef7\u683c\u4fdd\u969c"
      },
      "ar":
      {
        "tag": "\u0636\u0645\u0627\u0646 \u0623\u0641\u0636\u0644 \u0627\u0644\u0623\u0633\u0639\u0627\u0631"
      },
      "hu":
      {
        "tag": "garant\u00e1lt legjobb \u00e1r"
      },
      "cs":
      {
        "tag": "garance nejni\u017e\u0161\u00ed ceny"
      },
      "sk":
      {
        "tag": "garantovan\u00e1 najlep\u0161ia cena"
      },
      "ro":
      {
        "tag": "cel mai bun pre\u021b garantat"
      },
      "pl":
      {
        "tag": "najlepsza cena gwarantowana"
      }
    }
  },
  {
    "template_id": 2,
    "tag_code": "mi reserva",
    "has_plural": false,
    "active": true,
    "id": 641,
    "translations":
    {
      "en":
      {
        "tag": "My Booking"
      },
      "it":
      {
        "tag": "La mia prenotazione"
      },
      "fr":
      {
        "tag": "Ma r\u00e9servation"
      },
      "de":
      {
        "tag": "Meine Reservierung"
      },
      "pt":
      {
        "tag": "A minha Reserva"
      },
      "ru":
      {
        "tag": "\u041c\u043e\u0435 \u0431\u0440\u043e\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435"
      },
      "nl":
      {
        "tag": "Mijn reservering"
      },
      "ca":
      {
        "tag": "Mi reserva"
      },
      "es":
      {
        "tag": "mi reserva"
      },
      "tr":
      {
        "tag": "My Booking"
      },
      "zi":
      {
        "tag": "My Booking"
      },
      "ar":
      {
        "tag": "My Booking"
      },
      "hu":
      {
        "tag": "My Booking"
      },
      "cs":
      {
        "tag": "My Booking"
      },
      "sk":
      {
        "tag": "My Booking"
      },
      "ro":
      {
        "tag": "My Booking"
      },
      "pl":
      {
        "tag": "My Booking"
      }
    }
  },
  {
    "template_id": 2,
    "tag_code": "*Ni\u00f1os de 2 a 11 a\u00f1os",
    "has_plural": false,
    "active": true,
    "id": 612,
    "translations":
    {
      "es":
      {
        "tag": "*Ni\u00f1os de 2 a 11 a\u00f1os"
      },
      "ca":
      {
        "tag": "* Nens de 2 a 11 anys"
      },
      "en":
      {
        "tag": "*Children from 2 to 11 years old"
      },
      "fr":
      {
        "tag": "*Enfants de 2 \u00e0 11 ans"
      },
      "de":
      {
        "tag": "*Kinder von 2 bis 11 Jahren"
      },
      "it":
      {
        "tag": "*Bambini da 2 a 11 anni"
      },
      "nl":
      {
        "tag": "*Kinderen van 2 tot 11 jaar"
      },
      "pt":
      {
        "tag": "*Crian\u00e7as dos 2 aos 11 anos"
      },
      "ru":
      {
        "tag": "*\u00a0\u0414\u0435\u0442\u0438 \u043e\u0442 2 \u0434\u043e 11 \u043b\u0435\u0442"
      },
      "tr":
      {
        "tag": "*Children from 2 to 11 years old"
      },
      "zi":
      {
        "tag": "*Children from 2 to 11 years old"
      },
      "ar":
      {
        "tag": "*Children from 2 to 11 years old"
      },
      "hu":
      {
        "tag": "*Children from 2 to 11 years old"
      },
      "cs":
      {
        "tag": "*Children from 2 to 11 years old"
      },
      "sk":
      {
        "tag": "*Children from 2 to 11 years old"
      },
      "ro":
      {
        "tag": "*Children from 2 to 11 years old"
      },
      "pl":
      {
        "tag": "*Children from 2 to 11 years old"
      }
    }
  },
  {
    "template_id": 3,
    "tag_code": "c\u00f3digo promocional",
    "group_code": null,
    "has_plural": false,
    "override": true,
    "active": true,
    "id": 454,
    "translations": {
      "es": { "tag": "c\u00f3digo promocional" },
      "ca": { "tag": "codi promocional" },
      "en": { "tag": "promo code" },
      "it": { "tag": "codice promozionale" },
      "de": { "tag": "angebotscode" },
      "pt": { "tag": "c\u00f3digo promocional" },
      "ru": { "tag": "\u043f\u0440\u043e\u043c\u043e\u043a\u043e\u0434" },
      "nl": { "tag": "promotiecode" },
      "fr": { "tag": "code promotionnel" },
      "tr": { "tag": "promosyon kodu" },
      "zi": { "tag": "\u4fc3\u9500\u4ee3\u7801" },
      "ar": {
        "tag": "\u0627\u0644\u0634\u0641\u0631\u0629 \u0627\u0644\u062a\u0631\u0648\u064a\u062c\u064a\u0629"
      },
      "hu": { "tag": "kedvezm\u00e9nyk\u00f3d" },
      "cs": { "tag": "prono k\u00f3d" },
      "sk": { "tag": "akciov\u00fd k\u00f3d" },
      "ro": { "tag": "cod promo\u021bional" },
      "pl": { "tag": "kod promocyjny" },
      "gl": { "tag": "c\u00f3digo promocional" },
      "bg": {
        "tag": "\u043f\u0440\u043e\u043c\u043e\u0446\u0438\u043e\u043d\u0430\u043b\u0435\u043d \u043a\u043e\u0434"
      },
      "ja": {
        "tag": "\u30d7\u30ed\u30e2\u30fc\u30b7\u30e7\u30f3\u30b3\u30fc\u30c9"
      },
      "vi": { "tag": "M\u00e3 khuy\u1ebfn m\u1ea1i" },
      "sl": { "tag": "koda za popust" },
      "sr": { "tag": "promo kod" }
    }
  },
  {
    "template_id": 3,
    "tag_code": "aplicado",
    "group_code": null,
    "has_plural": false,
    "override": false,
    "active": true,
    "id": 722,
    "translations": {
      "hu": { "tag": "\u00c9rv\u00e9nyes\u00edtve" },
      "it": { "tag": "Applicato" },
      "tr": { "tag": "Uyguland\u0131" },
      "cs": { "tag": "Pou\u017eito" },
      "ru": { "tag": "\u041f\u0440\u0438\u043c\u0435\u043d\u0435\u043d" },
      "nl": { "tag": "Toegepast" },
      "zi": { "tag": "\u5df2\u4f7f\u7528" },
      "pt": { "tag": "Aplicado" },
      "fr": { "tag": "Appliqu\u00e9" },
      "en": { "tag": "Applied" },
      "ca": { "tag": "Aplicat" },
      "de": { "tag": "Angewandt" },
      "ar": { "tag": "\u0645\u0637\u0628\u0642" },
      "gl": { "tag": "Aplicado" },
      "es": { "tag": "aplicado" },
      "bg": { "tag": "\u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u043e" },
      "ja": { "tag": "\u5fdc\u7528" },
      "vi": { "tag": "h\u1ecd" },
      "sl": { "tag": "uporabljen" }
    }
  },
  {
    "template_id": 3,
    "tag_code": "tengo un c\u00f3digo promocional",
    "group_code": null,
    "has_plural": false,
    "override": false,
    "active": true,
    "id": 725,
    "translations": {
      "ca": { "tag": "Tinc un codi promocional" },
      "en": { "tag": "I have a promotional code" },
      "it": { "tag": "Ho un codice promozionale" },
      "de": { "tag": "Ich habe einen Gutscheincode" },
      "pt": { "tag": "Tenho um c\u00f3digo promocional" },
      "ru": {
        "tag": "\u0423 \u043c\u0435\u043d\u044f \u0435\u0441\u0442\u044c \u043f\u0440\u043e\u043c\u043e\u043a\u043e\u0434"
      },
      "nl": { "tag": "Ik heb een promotiecode" },
      "fr": { "tag": "J\u2019ai un code promotionnel" },
      "tr": { "tag": "Promosyon kodum var" },
      "zi": { "tag": "\u6211\u6709\u4fc3\u9500\u7801" },
      "gl": { "tag": "Te\u00f1o un c\u00f3digo promocional" },
      "ar": {
        "tag": "\u0644\u062f\u064a \u0631\u0645\u0632 \u062a\u0631\u0648\u064a\u062c\u064a"
      },
      "hu": { "tag": "Rendelkezem prom\u00f3ci\u00f3s k\u00f3ddal" },
      "cs": { "tag": "M\u00e1m slevov\u00fd k\u00f3d" },
      "es": { "tag": "tengo un c\u00f3digo promocional" },
      "bg": {
        "tag": "\u0438\u043c\u0430\u043c \u043f\u0440\u043e\u043c\u043e\u0446\u0438\u043e\u043d\u0430\u043b\u0435\u043d \u043a\u043e\u0434"
      },
      "ja": {
        "tag": "\u30d7\u30ed\u30e2\u30fc\u30b7\u30e7\u30f3\u30b3\u30fc\u30c9\u3092\u6301\u3063\u3066\u3044\u308b"
      },
      "vi": { "tag": "T\u00f4i c\u00f3 m\u1ed9t m\u00e3 khuy\u1ebfn m\u1ea1i" },
      "sl": { "tag": "imam kodo za popust" }
    }
  },
  {
    "template_id": 3,
    "tag_code": "Insertar c\u00f3digo promocional",
    "group_code": null,
    "has_plural": false,
    "override": false,
    "active": true,
    "id": 497,
    "translations": {
      "es": { "tag": "Insertar c\u00f3digo promocional" },
      "ca": { "tag": "introduir codi promocional" },
      "en": { "tag": "enter promo code" },
      "it": { "tag": "inserisci il codice promozionale" },
      "de": { "tag": "angebotscode eingeben" },
      "pt": { "tag": "inserir c\u00f3digo promocional" },
      "ru": {
        "tag": "\u0432\u0432\u0435\u0441\u0442\u0438 \u043f\u0440\u043e\u043c\u043e\u043a\u043e\u0434"
      },
      "nl": { "tag": "promotiecode invoeren" },
      "fr": { "tag": "saisir code promotionnel" },
      "tr": { "tag": "promosyon kodunu girin" },
      "zi": { "tag": "\u8f93\u5165\u4fc3\u9500\u4ee3\u7801" },
      "ar": {
        "tag": "\u0625\u062f\u0631\u0627\u062c \u0627\u0644\u0634\u0642\u0631\u0629 \u0627\u0644\u062a\u0631\u0648\u064a\u062c\u064a\u0629"
      },
      "hu": { "tag": "kedvezm\u00e9nyk\u00f3d megad\u00e1sa" },
      "cs": { "tag": "vlo\u017ete propaga\u010dn\u00ed k\u00f3d" },
      "sk": { "tag": "zada\u0165 akciov\u00fd k\u00f3d" },
      "ro": { "tag": "introduce\u021bi codul promo\u021bional" },
      "pl": { "tag": "wpisz kod promocyjny" },
      "gl": { "tag": "insertar c\u00f3digo promocional" },
      "bg": {
        "tag": "\u0412\u044a\u0432\u0435\u0434\u0438 \u043f\u0440\u043e\u043c\u043e\u0446\u0438\u043e\u043d\u0430\u043b\u0435\u043d \u043a\u043e\u0434"
      },
      "ja": {
        "tag": "\u30d7\u30ed\u30e2\u30fc\u30b7\u30e7\u30f3\u30b3\u30fc\u30c9\u633f\u5165"
      },
      "vi": { "tag": "CH\u00c8N M\u00c3 KHUY\u1ebeN M\u00c3I" },
      "sl": { "tag": "Vnesite kodo za popust" }
    }
  },
  {
    "template_id": 3,
    "tag_code": "aplicar",
    "group_code": null,
    "has_plural": false,
    "override": false,
    "active": true,
    "id": 446,
    "translations": {
      "es": { "tag": "aplicar" },
      "ca": { "tag": "aplicar" },
      "en": { "tag": "apply" },
      "it": { "tag": "applica" },
      "de": { "tag": "anwenden" },
      "pt": { "tag": "aplicar" },
      "ru": { "tag": "\u043f\u0440\u0438\u043c\u0435\u043d\u0438\u0442\u044c" },
      "nl": { "tag": "toepassen" },
      "fr": { "tag": "appliquer" },
      "tr": { "tag": "uygula" },
      "zi": { "tag": "\u4f7f\u7528" },
      "ar": { "tag": "\u062a\u0637\u0628\u064a\u0642" },
      "hu": { "tag": "alkalmaz\u00e1s" },
      "cs": { "tag": "pou\u017e\u00edt" },
      "sk": { "tag": "pou\u017ei\u0165" },
      "ro": { "tag": "aplica\u021bi" },
      "pl": { "tag": "zastosuj" },
      "gl": { "tag": "aplicar" },
      "bg": { "tag": "\u043f\u0440\u0438\u043b\u043e\u0436\u0438" },
      "ja": { "tag": "\u53cd\u6620\u3055\u305b\u308b" },
      "vi": { "tag": "\u0111\u00e3 \u00e1p d\u1ee5ng" },
      "sl": { "tag": "uporabiti" }
    }
  },
  {
    "template_id": 3,
    "tag_code": "* Precios aproximados para 2 personas.",
    "group_code": null,
    "has_plural": false,
    "override": false,
    "active": true,
    "id": 896,
    "translations": {
        "ca": { "tag": "* Preus aproximats per a 2 persones."},
        "en": { "tag": "* Approximate prices for 2 people."},
        "it": { "tag": "* Prezzi indicativi per 2 persone."},
        "de": { "tag": "* Gesch\u00e4tzte Preise f\u00fcr 2 Personen."},
        "pt": { "tag": "* Pre\u00e7os aproximados para 2 pessoas."},
        "ru": { "tag": "* \u041e\u0440\u0438\u0435\u043d\u0442\u0438\u0440\u043e\u0432\u043e\u0447\u043d\u044b\u0435 \u0446\u0435\u043d\u044b \u043d\u0430 2 \u0435\u043b\u043e\u0432\u0435\u043a."},
        "nl": { "tag": "* Richtprijzen voor 2 personen."},
        "fr": { "tag": "*\u00a0 Prix approximatifs pour 2 personnes."},
        "zi": { "tag": "*2\u4eba\u4f30\u7b97\u4ef7\u683c"},
        "gl": { "tag": "* Prezos aproximados para 2 persoas."},
        "ar": { "tag": "* \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0627\u0644\u062a\u0642\u0631\u064a\u0628\u064a\u0629 \u0644\u0634\u062e\u0635\u064a\u0646."},
        "hu": { "tag": "* Becs\u00fclt \u00e1rak 2 szem\u00e9ly r\u00e9sz\u00e9re."},
        "cs": { "tag": "* P\u0159ibli\u017en\u00e9 ceny pro 2 osoby."},
        "bg": { "tag": "* \u041f\u0440\u0438\u0431\u043b\u0438\u0437\u0438\u0442\u0435\u043b\u043d\u0438 \u0446\u0435\u043d\u0438 \u0437\u0430 2 \u0434\u0443\u0448\u0438."},
        "pl": { "tag": "* Przybli\u017cone ceny dla 2 os\u00f3b."},
        "sl": { "tag": "* Okvirne cene za 2 osebi."},
        "sr": { "tag": "* Pribli\u017ene cene za 2 osobe."},
        "es": { "tag": "* Precios aproximados para 2 personas."}
    }
  }
];
class I18n {
  constructor() {
    this.listLangs = ['en', 'es'];
    this.data = {};
  }

  extend = (i18n, lang) => {
    if (i18n) {
      this.data = Object.assign(this.data, i18n);
    }

    if (lang) {
      this.listLangs = [lang, 'en', 'es'];

      this.data = Object.assign(
        reduce(
          (i18n, translation) => {
            i18n[translation.tag_code] = defaults(
              {},
              { tag: this.translationFind(translation, 'tag'), has_plural: translation.has_plural }
            );
            i18n[translation.tag_code]['plural'] = translation.has_plural
              ? this.translationFind(translation, 'plural')
              : '';
            return i18n;
          },
          {},
          i18nData
        ),
        this.data
      );
    }
    return this;
  };

  translationFind = (translation, key) => {
    const lang = find(lang => get([lang, key], translation.translations))(this.listLangs);
    if (lang) {
      return get([lang, key], translation.translations);
    } else {
      return translation.tag_code;
    }
  };

  getHasKeyAndContent = code => {
    code = code
      .trim()
      .replace('_%', '')
      .replace('%_', '');

    if (code === '') {
      return '';
    }

    if (this.hasKey(code) && this.data[code].tag) {
      return this.data[code].tag;
    }
  };

  hasKey = code => {
    if (typeof code !== 'string') {
      return code;
    }

    code = code
      .trim()
      .replace('_%', '')
      .replace('%_', '');

    if (code === '') {
      return '';
    }
    return !!this.data[code];
  };

  t = (code, plural) => {
    if (typeof code !== 'string') {
      return code;
    }
    code = code
      .trim()
      .replace('_%', '')
      .replace('%_', '');
    if (code === '') {
      return '';
    }

    if (this.data[code]) {
      if (typeof plural === 'boolean' && plural && this.data[code].has_plural) {
        return this.data[code].plural + (window.availabilityReactTestingMode ? '*' : '');
      } else if (typeof plural === 'number' && plural !== 1 && this.data[code].has_plural) {
        return this.data[code].plural + (window.availabilityReactTestingMode ? '*' : '');
      } else {
        return (isNil(this.data[code].tag) ?  ""  : this.data[code].tag) + (window.availabilityReactTestingMode ? '*' : '');
      }
    } else {
      return code + (window.availabilityReactTestingMode ? '**' : '');
    }
  };
}

let contentGetInstance = null;
export const contentGetter = (i18n, lang) => {
  const baseI18n = contentGetInstance ? contentGetInstance : (contentGetInstance = new I18n());
  return baseI18n.extend(i18n, lang);
}